import apiFeedbackTrainers from '@/api/feedback-trainers'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  feedbackInfo: null,
}

export const mutationTypes = {
  getFeedbackTrainersInfoStart:
    '[feedback trainers info] Get feedback trainers info start',
  getFeedbackTrainersInfoSuccess:
    '[feedback trainers info] Get feedback trainers info success',
  getFeedbackTrainersInfoFailure:
    '[feedback trainers info] Get feedback trainers info failure',

  updateFeedbackTrainersInfoStart:
    '[feedback trainers info] Update feedback trainers info start',
  updateFeedbackTrainersInfoSuccess:
    '[feedback trainers info] Update feedback trainers info success',
  updateFeedbackTrainersInfoFailure:
    '[feedback trainers info] Update feedback trainers info failure',
}

export const actionTypes = {
  getFeedbackTrainersInfo:
    '[feedback trainers info] Get feedback trainers info',
  updateFeedbackTrainersInfo:
    '[feedback trainers info] Update feedback trainers info',
}

const mutations = {
  [mutationTypes.getFeedbackTrainersInfoStart](state) {
    state.isLoading = true
    state.feedbackInfo = null
  },

  [mutationTypes.getFeedbackTrainersInfoSuccess](state, payload) {
    state.feedbackInfo = payload
    state.isLoading = false
  },

  [mutationTypes.getFeedbackTrainersInfoFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.updateFeedbackTrainersInfoStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateFeedbackTrainersInfoSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateFeedbackTrainersInfoFailure](state) {
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.getFeedbackTrainersInfo](context, {id}) {
    context.commit(mutationTypes.getFeedbackTrainersInfoStart)
    return new Promise((resolve) => {
      apiFeedbackTrainers
        .getFeedbackTrainersInfo(id)
        .then((response) => {
          context.commit(
            mutationTypes.getFeedbackTrainersInfoSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getFeedbackTrainersInfoFailure)
        })
    })
  },

  [actionTypes.updateFeedbackTrainersInfo](context, {feedbackId, data}) {
    context.commit(mutationTypes.updateFeedbackTrainersInfoStart)

    return new Promise((resolve) => {
      apiFeedbackTrainers
        .changeFeedbackTrainersStatus(feedbackId, data)
        .then((response) => {
          context.commit(
            mutationTypes.updateFeedbackTrainersInfoSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.updateFeedbackTrainersInfoFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
